
function renderName(name) {
  let title = '';
  if(name){
    var t = name.replace(/-/g, ' ').replace(/_/g, ' ');
    title = t.charAt(0).toUpperCase() + t.slice(1);
  }
  return title;
}
function pad(pad, str, padLeft) {
  if (typeof str === 'undefined') 
    return pad;
  if (padLeft) {
    return (pad + str).slice(-pad.length);
  } else {
    return (str + pad).substring(0, pad.length);
  }
}
const GeneralUtil = { renderName, pad };
export default GeneralUtil;


// WEBPACK FOOTER //
// ./src/utils/GeneralUtil.js